'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Badge = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\tposition: relative; \n\n\t&:after {\n\t\tcontent: attr(value);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: absolute;\n\t\twhite-space: nowrap;\n\t\ttop: -24px;\n\t\tright: -24px;\n\t\tfont-size: 12px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ', ';\n\t\tcolor: #fff;\n\t\tfont-family: ', ';\n\t}\n'], ['\n\tposition: relative; \n\n\t&:after {\n\t\tcontent: attr(value);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tposition: absolute;\n\t\twhite-space: nowrap;\n\t\ttop: -24px;\n\t\tright: -24px;\n\t\tfont-size: 12px;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tborder-radius: 50%;\n\t\tbackground-color: ', ';\n\t\tcolor: #fff;\n\t\tfont-family: ', ';\n\t}\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColor = _utils2.default.getColor;


var Badge = _styledComponents2.default.span(_templateObject, function (props) {
	return getColor(props);
}, _globals2.default.fonts.regular);

exports.Badge = Badge;